import { createApp } from 'vue';
import { createPinia } from 'pinia';
import autosuggestSearchApp from '@/app/views/autosuggest-search/autosuggest-search.vue';
import { pushToDataLayer } from '@/js/analytics/analytics.methods';

export default class autosuggestSearch {
  constructor(el) {
    this.el = el;
    this.isHeaderSearch = el.dataset.headerSearch;
    this.componentId = el.id;
    this.langCode = document.documentElement.lang;
    this.init();
  }
  init() {
    const app = createApp(autosuggestSearchApp, {
      isHeaderSearch: this.isHeaderSearch === 'true',
      langCode: this.langCode,
      id: this.componentId,
    });
    const pinia = createPinia();

    app.provide('config', JCB);
    app.provide('gaPush', pushToDataLayer);
    app.use(pinia);
    app.mount(this.el);
  }
}
